import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Pide abrir la venta del dashboard. Sirve cuando el modal de baja vive fuera
 * de esa pantalla y el usuario elige Vender.
 */
@Injectable({
  providedIn: 'root',
})
export class SellIntentService {
  private pending = false;
  private readonly requestsSubject = new Subject<void>();
  readonly requests$ = this.requestsSubject.asObservable();

  request(): void {
    this.pending = true;
    this.requestsSubject.next();
  }

  hasPending(): boolean {
    return this.pending;
  }

  consume(): void {
    this.pending = false;
  }
}
